import { useEffect, useState } from 'react';

const links = [
  { href: '#hot', label: '今日热榜' },
  { href: '#category', label: '热门栏目' },
  { href: '#moments', label: '名场面' },
  { href: '#feeds', label: '热闻速览' },
  { href: '#faq', label: '常见问题' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        {/* Logo */}
        <h1 className="flex items-center gap-2">
          <a href="#top" className="flex items-center gap-2" aria-label="反差吃瓜 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-water-flash-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="whitespace-nowrap text-lg font-black tracking-wide text-foreground-950">
              反差<span className="text-primary-600">吃瓜</span>
            </span>
          </a>
        </h1>

        {/* Desktop nav */}
        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#subscribe"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅速报
          </a>
        </nav>

        {/* Mobile toggle */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <nav aria-label="移动端导航" className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-xl px-4 py-3 text-base font-medium text-foreground-800 hover:bg-primary-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-xl bg-primary-500 px-4 py-3 text-center text-base font-bold text-background-50"
            >
              订阅速报
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}